export interface CustomPictureProperties {
    /**
     * The ID attribute for the component.
     */
    id?: string;

    /**
     * Class name to apply styles to the root element.
     */
    className?: string;

    /**
     * Image name to render as selected in Amplience or from a URL.
     */
    name: string;

    /**
     * Description text for accessibility.
     */
    alt?: string;

    /**
     * Should the image be lazy loaded?
     */
    lazy?: boolean;

    /**
     * Amplience API query
     */
    query?: ImageMediaQuery;
}

export interface ImageMediaQuery {
    default?: QueryParameters;
    mobile?: QueryParameters;
}

export interface QueryParameters {
    w?: string;
    h?: string;
    maxW?: string;
    maxH?: string;
    fmt?: string;
    sm?: SCALE_MODE;
    aspect?: string;
    crop?: CropImageQuery;
    poi?: PointOfInterest;
    qlt?: string;
    $poi$?: string;
    $qlt$?: string;
}

export enum SCALE_MODE {
    CROP = 'c',
    STRETCH = 's',
    TOP_LEFT = 'tl',
    TOP_CENTER = 'tc',
    TOP_RIGHT = 'tr',
    MIDDLE_LEFT = 'ml',
    MIDDLE_CENTER = 'mc',
    MIDDLE_RIGHT = 'mr',
    BOTTOM_LFET = 'bl',
    BOTTOM_CENTER = 'bc',
    BOTTOM_RIGHT = 'br',
    ASPECT = 'aspect',
}

/**
 * The focal point of an image to use when it is resized and cropped.
 * Takes 4 parameters: x, y, w and h. x and y represent the top left of the focal point
 * as a percentage of the image width and height. Width and height are the width and
 * height of the focal point as a percentage of the image width and height
 *
 * Example in query
 * poi= 0.743636237250434,0.,0.32362459546925565, 0.1388888888888889 0
 *
 * @param {string} x - is the offset from the top left of the image
 * @param {string} y - is the offset from the top of the image.
 * @param {string} width - width is the width of the selection.
 * @param {string} height - height is the height of the selection.
 */

export interface PointOfInterest {
    x: string;
    y: string;
    width: string;
    height: string;
}

/**
 * Cuts out a section of the image, the coordinates are specified as x,y,w,h.
 * Values can be provided in pixels (as number, e.g. '100') or in persentage ('33%')
 *
 * @param {string} x - is the offset from the top left of the image
 * @param {string} y - is the offset from the top of the image.
 * @param {string} width - width is the width of the selection.
 * @param {string} height - height is the height of the selection.
 */

export interface CropImageQuery {
    x: string;
    y: string;
    width: string;
    height: string;
}

export interface UrlMediaSet {
    defaultUrl: string;
    mobileUrl: string;
}
